module.exports = __webpack_public_path__ + "static/img/point-icon@m.f1bc505.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/glovis-aa/point-icon@m.png
// module id = Afk4
// module chunks = 0